import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "number-box" }

import { computed } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { AreaSearch } from '@/components/business/crud/interface/SearchType';
import {
  getArea,
  getOptions,
} from '@/components/business/crud/widgets/impl/area';


export default /*#__PURE__*/_defineComponent({
  __name: 'AreaSearch',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const value = computed({
  get() {
    if (data.value[props.propName]?.$like) {
      return getArea(
        data.value[props.propName]?.$like.slice(0, -1).padEnd(6, '0')
      ).ids;
    } else {
      return undefined;
    }
  },
  set(val?: string[]) {
    if (val) {
      data.value[props.propName] = {
        $like: val[val.length - 1].replace(/0*$/, '') + '%',
      };
      console.log('set', data.value[props.propName]);
    } else {
      data.value[props.propName] = undefined;
    }
  },
});

return (_ctx: any,_cache: any) => {
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_cascader, {
      value: value.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      options: _unref(getOptions)(),
      placeholder: '请选择' + _ctx.info.title,
      "change-on-select": "",
      "show-search": { filter: _ctx.filter },
      style: {"width":"100%"}
    }, null, 8, ["value", "options", "placeholder", "show-search"])
  ]))
}
}

})